import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/routes/login/login.component';
import { ShellComponent } from './features/layout/routes/shell/shell.component';
import { MembershipGuard } from './features/auth/services/membership.guard';
import { NoMembershipComponent } from './features/auth/routes/no-membership/no-membership.component';
import { MinimalShellComponent } from './features/layout/routes/minimal-shell/minimal-shell.component';
import { AuthRedirectGuard } from './features/auth/services/auth-redirect.guard';
import { LoggedoutComponent } from './features/auth/routes/loggedout/loggedout.component';

export const routes: Routes = [
  {
    path: 'auth',
    component: LoginComponent,
    title: 'Min Side | Logg inn',
  },
  {
    path: 'logget-ut',
    component: LoggedoutComponent,
    title: 'Min Side | Logget ut',
  },
  { path: '', redirectTo: 'access-gate', pathMatch: 'full' },
  {
    path: 'access-gate',
    component: MinimalShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/layout/routes/access-gate/access-gate.component').then((m) => m.AccessGateComponent),
        title: 'Min Side | Logger inn',
      },
    ],
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthRedirectGuard],
    children: [
      {
        path: 'cookies',
        loadComponent: () =>
          import('./features/legal/routes/cookies/cookies.component').then((m) => m.CookiesComponent),
        title: 'Håndter cookies | Fagforbundet',
        data: { breadcrumb: 'Cookies' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/routes/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [MembershipGuard],
        title: 'Min Side | Fagforbundet',
      },
      {
        path: 'mitt-medlemskap',
        loadComponent: () =>
          import('./features/my-membership/routes/my-membership.component').then((mod) => mod.MyMembershipComponent),
        title: 'Mitt medlemskap | Min Side',
        data: { breadcrumb: 'Mitt medlemskap' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'fagforening',
        loadComponent: () =>
          import('./features/my-union/routes/my-union.component').then((mod) => mod.MyUnionComponent),
        title: 'Min fagforening | Min Side',
        data: { breadcrumb: 'Min fagforening' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'tariffavtale',
        loadComponent: () =>
          import('./features/my-collective-agreement/routes/my-collective-agreement.component').then(
            (mod) => mod.MyCollectiveAgreementComponent
          ),
        title: 'Min tariffavtale | Min Side',
        data: { breadcrumb: 'Min tariffavtale' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'tillitsvalgt',
        loadComponent: () =>
          import('./features/my-shop-steward/routes/my-shop-steward.component').then(
            (mod) => mod.MyShopStewardComponent
          ),
        title: 'Min tillitsvalgt | Min Side',
        data: { breadcrumb: 'Mitt tillitsvalgt' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'verving',
        loadComponent: () =>
          import('./features/enlistment/routes/enlistment.component').then((mod) => mod.EnlistmentComponent),
        title: 'Verving | Min Side',
        data: { breadcrumb: 'Verving' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'forsikringer',
        loadComponent: () =>
          import('./features/my-insurances/routes/my-insurances.component').then((mod) => mod.MyInsurancesComponent),
        title: 'Forsikringer | Min Side',
        data: { breadcrumb: 'Forsikringer' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'stipend',
        loadComponent: () =>
          import('./features/scholarship/routes/scholarship.component').then((mod) => mod.ScholarshipComponent),
        title: 'Stipend | Min Side',
        data: { breadcrumb: 'Stipend' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'stipend/:id',
        loadComponent: () =>
          import('./features/scholarship/routes/apply-scholarship/apply-scholarship.component').then(
            (mod) => mod.ApplyScholarshipComponent
          ),
        title: 'Søk Stipend | Min Side',
        data: { breadcrumb: 'Søk Stipend' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'kontingent',
        loadComponent: () => import('./features/my-dues/routes/my-dues.component').then((mod) => mod.MyDuesComponent),
        title: 'Kontingent | Min Side',
        data: { breadcrumb: 'Min kontingent' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'reiseregning',
        loadComponent: () =>
          import('./features/travel-expenses/routes/travel-expenses.component').then(
            (mod) => mod.TravelExpensesComponent
          ),
        title: 'Reiseregninger | Min Side',
        data: { breadcrumb: 'Reiseregninger' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'yrkesseksjon',
        loadComponent: () =>
          import('./features/vocational-section/routes/vocational-section.component').then(
            (mod) => mod.VocationalSectionComponent
          ),
        title: 'Yrkesseksjoner | Min Side',
        data: { breadcrumb: 'Yrkesseksjoner' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'rettigheter-og-fordeler',
        loadComponent: () =>
          import('./features/rights-and-benefits/routes/rights-and-benefits.component').then(
            (mod) => mod.RightsAndBenefitsComponent
          ),
        title: 'Rettigheter og fordeler | Min Side',
        data: { breadcrumb: 'Rettigheter og fordeler' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'kontakt-oss',
        loadComponent: () =>
          import('./features/contact-us/routes/contact-us.component').then((mod) => mod.ContactUsComponent),
        title: 'Kontakt oss | Min Side',
        data: { breadcrumb: 'Kontakt oss' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'min-profil',
        loadComponent: () =>
          import('./features/user-profile/routes/user-profile.component').then((mod) => mod.UserProfileComponent),
        title: 'Din profil | Fagforbundet',
        data: { breadcrumb: 'Din profil' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'utmelding',
        loadComponent: () =>
          import('./features/cancel-membership/routes/cancel-membership.component').then(
            (mod) => mod.CancelMembershipComponent
          ),
        title: 'Utmelding | Fagforbundet',
        data: { breadcrumb: 'Utmelding' },
        canActivate: [MembershipGuard],
      },
      {
        path: 'utmelding/arsak',
        loadComponent: () =>
          import('./features/cancel-membership/routes/reason/cancel-membership-reason.component').then(
            (mod) => mod.CancelMembershipReasonComponent
          ),
        title: 'Årsak til utmelding | Fagforbundet',
        canActivate: [MembershipGuard],
        data: { breadcrumb: 'Årsak til utmelding', parent: 'utmelding' },
      },
      {
        path: 'utmelding/bekreftelse',
        loadComponent: () =>
          import('./features/cancel-membership/routes/confirmation/cancel-membership-confirmation.component').then(
            (mod) => mod.CancelMembershipConfirmationComponent
          ),
        title: 'Utmelding mottatt | Fagforbundet',
        canActivate: [MembershipGuard],
        data: { breadcrumb: 'Utmelding mottatt', parent: 'utmelding' },
      },
    ],
  },
  {
    path: 'no-access',
    component: MinimalShellComponent,
    canActivate: [AuthRedirectGuard],
    children: [
      {
        path: '',
        component: NoMembershipComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
